import "./style.css";
const DenialItem = ({ label, value }) => {
  const getStatus = () => {
    const v = value?.toLowerCase() || "";

    if (
      v.includes("fail") ||
      v.includes("reject") ||
      v.includes("not verified") ||
      v.includes("error")
    )
      return "error";

    if (
      v.includes("verified") ||
      v.includes("success") ||
      v.includes("approved")
    )
      return "success";

    return "";
  };

  return (
    <div>
      <div className="denial-label">{label}</div>
      <div className={`denial-value ${getStatus()}`}>{value}</div>
    </div>
  );
};

const TransactionDenialCard = ({ denialCode, requestTimestamp, reason }) => {
  return (
    <div className="denial-section">
      <div className="denial-title">Denial Details</div>

      <div className="denial-card">
        <div className="denial-grid">
          <DenialItem label="Denial Code" value={denialCode || "-"} />

          <DenialItem
            label="Request Timestamp"
            value={requestTimestamp || "-"}
          />
        </div>

        <div className="denial-reason">
          <div className="denial-label">Reason</div>
          <p>{reason || "-"}</p>
        </div>
      </div>
    </div>
  );
};

export default TransactionDenialCard;
